(() => {
  const startLabels = new Set(['무료보기', '무료 보기', '무료로 보기', '무료 시작', '무료 시작하기', '무료로 시작', '무료로 시작하기', '무료 풀이 보기', '무료 풀이부터 보기', '소리 켜고 시작', 'Try free', 'Try for free', 'Start free', 'Start for free', 'Start Free', 'Start for Free', 'Watch for free', 'View for free', '無料で見る', '無料ではじめる', '無料で始める', '無料スタート', '시작하기', '始める',
    // 10/7 번체 중국어 — 사전이 먼저 옮긴 시작 단추 글(대만 · 홍콩)
    '免費看', '免費開始', '先看免費解析', '先看免費解讀', '開啟聲音開始', '開啟聲音並開始']);
  const agreeLabels = new Set(['동의하고 무료 시작', '동의하고 무료 시작하기', 'Agree and start for free', '同意して無料ではじめる', '同意して無料で始める', '同意並免費開始']);
  // 10/22 이 파일이 넣는 글(시작 · 동의하고 시작) — 표 하나에서 꺼내 인식 목록에도 넣는다. 어느 말씨에서 와도 지금 말씨 글로 다시 바뀐다
  const labels = {ko: ['시작', '동의하고 시작'], en: ['Start', 'Agree and start'], ja: ['はじめる', '同意してはじめる'], 'zh-TW': ['開始', '同意並開始'], 'zh-HK': ['開始', '同意並開始']};
  for (const [start, agree] of Object.values(labels)) { startLabels.add(start); agreeLabels.add(agree); }
  const controls = 'button,[role="button"],input[type="button"],input[type="submit"],a.cta,a.ed-primary,.ed-primary,a.btn,a.button';
  // 10/7 번체 중국어 — 주소의 lang(zh-tw · zh-Hant-HK · zh-MO …)도 i18n.js 와 같게 zh-TW · zh-HK 로 맞춘다
  const locale = () => { const value = new URLSearchParams(location.search).get('lang') || window.BGLANG?.locale || document.documentElement.lang || 'ko'; return /^zh(?:[-_]|$)/i.test(value) ? (/^zh(?:[-_]hant)?[-_](?:hk|mo)(?:[-_]|$)/i.test(value) ? 'zh-HK' : 'zh-TW') : value; };
  const label = agree => (labels[locale()] || labels.en)[agree ? 1 : 0];
  function kind(value) {
    const text = String(value || '').trim();
    return agreeLabels.has(text) ? 'agree' : startLabels.has(text) ? 'start' : null;
  }
  function update(root) {
    const elements = root.nodeType === 1 ? [root, ...root.querySelectorAll(controls)] : [];
    for (const el of elements) {
      if (!el.matches(controls)) continue;
      for (const attr of ['aria-label', 'title', ...(el.tagName === 'INPUT' ? ['value'] : [])]) {
        const type = kind(el.getAttribute(attr));
        if (type) el.setAttribute('data-start-'+attr, type);
        const stored = el.getAttribute('data-start-'+attr);
        if (stored) { const text = label(stored === 'agree'); if (el.getAttribute(attr) !== text) el.setAttribute(attr, text); }
      }
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      for (let node = walker.nextNode(); node; node = walker.nextNode()) {
        const type = kind(node.nodeValue), parent = node.parentElement;
        if (!parent || parent.closest('script,style,svg')) continue;
        if (type) { parent.setAttribute('data-start-label', type); parent.setAttribute('data-i18n-skip', ''); const text = label(type === 'agree'); if (node.nodeValue !== text) node.nodeValue = text; }
        // 10/8 점검 — 시작 단추 글 칸은 위에서 data-i18n-skip 을 붙여, 나중에 들어오는 다른 글(「이어 보기」 등)을 사전이 옮기지 않았다. 여기서 옮긴다
        else if (parent.hasAttribute('data-start-label') && window.BGLANG) { const text = window.BGLANG.t(node.nodeValue); if (text !== node.nodeValue) node.nodeValue = text; }
      }
    }
  }
  function init() {
    update(document.body);
    new MutationObserver(records => {
      const roots = new Set();
      for (const record of records) {
        if (record.type === 'characterData') { const control = record.target.parentElement?.closest(controls); if (control) roots.add(control); }
        else if (record.type === 'attributes') roots.add(record.target);
        else for (const node of record.addedNodes) if (node.nodeType === 1) roots.add(node); else { const control = node.parentElement?.closest(controls); if (control) roots.add(control); }
      }
      roots.forEach(update);
    }).observe(document.body, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['aria-label','title','value']});
    for (const event of ['bamgwabi:locale-change','bamgwabi:locale-ready']) document.addEventListener(event, () => update(document.body));
  }
  if (document.body) init(); else document.addEventListener('DOMContentLoaded', init, {once:true});
})();
